import React from 'react';
import { render } from 'react-dom';

class ErrorMessage extends React.Component {
    render() {
        return (
            <div className="error-message">
                <span>
                    An error has occurred. Please try reloading the page. <br />
                    If the problem persists, please call 1-888-WB-MASON.
                </span>
            </div>
        );
    }

}

export default ErrorMessage;  